<template>
  <div v-if="showCheckoutForm" class="col-12 col-md-8 col-lg-6">
    <div class="section_inner" ref="sectionDom">
      <FormWizard :initial-step="initialStep" :validation-schema="validationSchema" :initial-values="formInitialValues"
                  @submit="onSubmit"
                  @stepChange="event => stepChange(event)" @mailUsed="mailUsed" :product="product" :paid-success="paidSuccess">
        <FormStep>
          <p class="box_title">設定會員信箱</p>
          <div class="box_content">
            <p class="box_text">此為您的電子報收件信箱與登入帳號，請確認填寫無誤</p>
          </div>

          <Field name="email" v-slot="{ field, errorMessage }" validateOnInput>
            <div class="box_content form-group" :class="errorMessage?'error':''" :data-name="'checkout_'+field.name">
              <label for="checkoutEmail">請輸入Email地址</label>
              <input v-bind="field" type="email" id="checkoutEmail" :aria-describedby="'checkout_'+field.name+'Help'"
                     class="form-control"
                     placeholder="exemple@mail.com"
                     :readonly="initialStep > 0"
                    @focus="inputFocusFunc"
                    @blur="inputBlurFunc">
              <small :id="'checkout_'+field.name+'Help'" class="form-text">{{ errorMessage }}</small>
            </div>
          </Field>

          <div class="box_content">
            <p class="box_text desc">點選確認即視為同意我方將email資訊用於行銷目的</p>
          </div>
        </FormStep>

        <FormStep>
          <p class="box_title">填寫會員資料</p>
          <Field name="nickname" v-slot="{ field, errorMessage }" validateOnInput>
            <div class="box_content form-group" :class="errorMessage?'error':''" :data-name="'checkout_'+field.name">
              <label for="checkoutNickname">怎麼稱呼您？</label>
              <input v-bind="field" type="text" id="checkoutNickname" maxlength="6"
                     :aria-describedby="'checkout_'+field.name+'Help'"
                     class="form-control"
                     placeholder=""
                    @focus="inputFocusFunc"
                    @blur="inputBlurFunc">
              <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                  errorMessage ? errorMessage : '限6個字，不可使用空白或特殊符號'
                }}</small>
            </div>
          </Field>

          <Field name="password" v-slot="{ field, errorMessage }" validateOnInput>
            <div class="box_content form-group" :class="errorMessage?'error':''" :data-name="'checkout_'+field.name">
              <label for="checkoutPassword">設定密碼</label>
              <input v-bind="field" type="password" id="checkoutPassword" maxlength="20"
                     :aria-describedby="'checkout_'+field.name+'Help'"
                     class="form-control"
                     placeholder=""
                    @focus="inputFocusFunc"
                    @blur="inputBlurFunc">
              <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                  errorMessage ? errorMessage : '6-20位英數(須包含1個數字、1個英文字母)'
                }}</small>
            </div>
          </Field>

          <Field name="confirm" v-slot="{ field, errorMessage }" validateOnInput>
            <div class="box_content form-group" :class="errorMessage?'error':''" :data-name="'checkout_'+field.name">
              <label for="checkoutConfirmPassword">確認密碼</label>
              <input v-bind="field" type="password" id="checkoutConfirmPassword" maxlength="20"
                     :aria-describedby="'checkout_'+field.name+'Help'" class="form-control"
                     placeholder=""
                    @focus="inputFocusFunc"
                    @blur="inputBlurFunc">
              <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                  errorMessage ? errorMessage : '請再次輸入密碼'
                }}</small>
            </div>
          </Field>
        </FormStep>

        <FormStep>
          <div class="box_inner">
            <p class="box_title">信用卡資訊</p>
            <Field name="creditCard" v-slot="{ field, errorMessage, handleChange }" validateOnInput>
              <div class="box_content form-group" :class="errorMessage?'error':''" :data-name="'checkout_'+field.name">
                <label for="checkoutCreditCard">請輸入信用卡號</label>
                <input @input="event => handleChange(cardNoFormat(event), true)" :value="field.value" type="tel"
                       id="checkoutCreditCard" maxlength="19" inputmode="numeric" pattern="[0-9\s]{13,19}"
                       :aria-describedby="'checkout_'+field.name+'Help'" class="form-control" autocomplete="cc-number"
                       placeholder="0000 0000 0000 0000"
                      @focus="inputFocusFunc"
                      @blur="inputBlurFunc">
                <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                    errorMessage ? errorMessage : ''
                  }}</small>
              </div>
            </Field>
            <div class="row">
              <div class="col-12 col-sm-6">
                <Field name="creditMY" v-slot="{ field, errorMessage, handleChange }" validateOnInput>
                  <div class="box_content form-group input_wrapper" :class="errorMessage?'error':''"
                       :data-name="'checkout_'+field.name">
                    <label for="checkoutCreditMY">請輸入有效月/年</label>
                    <input @input="event => handleChange(expireDateFormat(event), true)" :value="field.value" type="tel"
                           class="form-control" id="checkoutCreditMY" placeholder="MM / YY"
                           maxlength="7" :aria-describedby="'checkout_'+field.name+'Help'" @focus="inputFocusFunc" @blur="inputBlurFunc">
                    <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                        errorMessage ? errorMessage : ''
                      }}</small>
                  </div>
                </Field>
              </div>
              <div class="col-12 col-sm-6">
                <Field name="creditCVV" v-slot="{ field, errorMessage }"
                       validateOnInput>
                  <div class="box_content form-group input_wrapper" :class="errorMessage?'error':''"
                       :data-name="'checkout_'+field.name">
                    <label for="checkoutCreditCVV">請輸入安全碼</label>
                    <input v-bind="field" type="tel" class="form-control" id="checkoutCreditCVV" maxlength="3"
                           pattern="[0-9]{3}"
                           :aria-describedby="'checkout_'+field.name+'Help'"
                            @focus="inputFocusFunc"
                            @blur="inputBlurFunc">
                    <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                        errorMessage ? errorMessage : ''
                      }}</small>
                  </div>
                </Field>
              </div>
            </div>
          </div>
          <div class="box_inner invoice">
            <p class="box_title">發票</p>
            <div class="form-group">
              <div class="form-control select_wrapper">
                <Field v-slot="{ value }" @change="event => invoiceChange(event)" name="invoiceType" as="select">
                  <option value="1">個人電子發票</option>
                  <option value="2">公司戶發票</option>
                </Field>
                <span class="select_arrow">
                  <svg focusable="false" class="select_arrow_svg" xmlns="http://www.w3.org/2000/svg"
                       viewBox="0 0 24 24">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                  </svg>
                </span>
              </div>
            </div>
            <Field name="invoiceTitle" v-slot="{ field, errorMessage }" validateOnInput>
              <div v-show="isCompanyType" class="box_content form-group" :class="errorMessage?'error':''"
                   :data-name="'checkout_'+field.name">
                <label for="checkoutInvoiceTitle">請輸入公司抬頭？</label>
                <input v-bind="field" type="text" id="checkoutInvoiceTitle"
                       :aria-describedby="'checkout_'+field.name+'Help'"
                       class="form-control" @focus="inputFocusFunc" @blur="inputBlurFunc">
                <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                    errorMessage ? errorMessage : ''
                  }}</small>
              </div>
            </Field>
            <Field name="invoiceUniform" v-slot="{ field, errorMessage }"
                   validateOnInput>
              <div v-show="isCompanyType" class="box_content form-group" :class="errorMessage?'error':''"
                   :data-name="'checkout_'+field.name">
                <label for="checkoutInvoiceUniform">請輸入統編</label>
                <input v-bind="field" type="tel" class="form-control" id="checkoutInvoiceUniform" maxlength="8"
                       pattern="[0-9]{8}"
                       :aria-describedby="'checkout_'+field.name+'Help'"
                      @focus="inputFocusFunc"
                      @blur="inputBlurFunc">
                <small :id="'checkout_'+field.name+'Help'" class="form-text">{{
                    errorMessage ? errorMessage : '送出後無法更改，請務必確認'
                  }}</small>
              </div>
            </Field>
          </div>
        </FormStep>

        <FormStep>
          <p class="box_title">訂單明細</p>
          <div class="box_inner">
            <div class="box_content">
              <span class="box_text key">登入信箱 </span>
              <span class="box_text value">{{initialEmail}}</span>
            </div>
          </div>
          <div class="box_content sub">
            <p class="box_text">您的方案</p>
          </div>
          <p class="box_title product">{{ products[product].title }}</p>
          <div class="box_content">
            <p class="box_text desc">您的{{ products[product].title }}將在{{ freeEnd }}{{ products[product].content }}</p>
          </div>
          <div class="box_content price_wrapper">
            <div v-if="false" class="price_content subtotal">
              <span class="price_label">小計</span>
              <span class="price_value">NT$1</span>
            </div>
            <div v-if="false"  class="price_content discount">
              <span class="price_label">折扣</span>
              <span class="price_value">NT$0</span>
            </div>
            <div class="price_content total">
              <span class="price_label">總計</span>
              <span class="price_value">NT$ {{products[product].price}}</span>
            </div>
          </div>
          <div v-if="false"  class="box_content row coupon_wrapper">
            <div class="col-9 col-sm-4">
              <div class="form-group">
                <label for="couponCode">折扣碼</label>
                <input type="password" class="form-control" id="couponCode" @focus="inputFocusFunc" @blur="inputBlurFunc">
              </div>
            </div>
            <div class="col-3 col-sm-2">
              <a href="javascript:void(0);" class="btn secondary md" id="couponSubmit">
                <span class="btn_text">確定</span>
              </a>
            </div>
          </div>
          <div class="box_content">
            <Field v-slot="{ field, errorMessage }" name="agreeTerms" type="checkbox" :value="true" validateOnInput>
              <div class="form-check" :class="errorMessage?'error':''">
                <input type="checkbox" class="form-check-input" id="checkoutAgreeTerms" v-bind="field" :value="true">
                <label class="form-check-label" for="checkoutAgreeTerms">
                  <span class="label_text">我已閱讀並同意世界走走的</span>
                  <a href="/terms-of-service" class="label_text link" target="_blank">會員服務條款</a>
                  <span class="label_text">和</span>
                  <a href="/privacy" class="label_text link" target="_blank">隱私權政策</a>
                </label>
              </div>
              <small :id="'checkout_'+field.name+'Help'" class="form-text">{{ errorMessage }}</small>
            </Field>
            <Field v-slot="{ field, errorMessage }" name="agreeOrder" type="checkbox" :value="true" validateOnInput>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="checkoutAgreeOrder" v-bind="field" :value="true">
                <label class="form-check-label" for="checkoutAgreeOrder">已確認訂單無誤，並同意每月自動續扣條款。</label>
              </div>
              <small :id="'checkout_'+field.name+'Help'" class="form-text">{{ errorMessage }}</small>
            </Field>
            <p class="box_text desc">本次訂閱將由藍新金流進行付款，藍新會將電子發票寄至您的信箱，若中獎亦會主動寄送紙本發票給您(僅限台灣區地址)。</p>
          </div>
        </FormStep>
        <FormStep>
          <template v-if="paidSuccess">
            <p class="box_title">訂閱完成</p>
            <div class="box_content">
              <p class="box_text">出發之前，世界走走已發送一封認證信至您的Email信箱{{paidEmail}}， 請於30分鐘內完成Email認證，以享受更美好的網站體驗！</p>
            </div>
            <div class="box_content">
              <p class="box_text">按下確認鍵回到首頁</p>
            </div>
          </template>
          <template v-else>
            <p class="box_title">訂閱未成功</p>
            <div class="box_content">
              <p class="box_text">噢不！訂閱未成功</p>
              <p class="box_text" v-if="errorMsg">{{errorMsg}}</p>
              <p class="box_text">請再次檢查您填寫的資料</p>
            </div>
          </template>
        </FormStep>
      </FormWizard>

    </div>
  </div>
  <show-login ref="sl"></show-login>
</template>

<script>
import {ref, computed, provide, onMounted} from 'vue';
import {Field, ErrorMessage} from "vee-validate";
import * as yup from "yup";
import FormWizard from "./FormWizard";
import FormStep from "./FormStep";
import {mockApiRequest, triggerErrorDialog, inputFocus, inputBlur} from "@vuePath/tools/tool"
import showLoginAfterOK from './showLoginAfterOK'
import {useStore} from "vuex";
import {checkoutPost} from "@vuePath/api/checkout"
import {checkMailUsed} from "@vuePath/api/member";

export default {
  name: "CheckoutApp",
  components: {
    FormWizard,
    FormStep,
    Field,
    ErrorMessage,
    'show-login': showLoginAfterOK
  },
  props: {
    product: {
      type: String,
      required: true
    },
    isVerified: {
      type: String,
      required: true
    },
    email: String
  },
  created() {
    window.localStorage.setItem('price', this.products[this.product].price);
  },
  setup(props) {
    const price = JSON.parse(localStorage.getItem("apiData"));
    const showCheckoutForm = ref(false);
    const store = useStore();
    const isLogin = store.getters['auth/isAuthenticated'];
    const showLogin = () => {
      store.dispatch('auth/ShowLogin');
    };
    provide('showLogin', showLogin);

    const validationSchema = [
      yup.object({
        email: yup.string().required("請輸入Email地址").email("格式錯誤，請再確認").label("Email Address"),
      }),
      yup.object({
        nickname: yup.string().required("請輸入您的暱稱").matches(/^[\u4e00-\u9fa5\w]{1,6}$/, {
          message: "限6個字，不可使用空白或特殊符號",
          excludeEmptyString: true
        }),
        password: yup.string().required("請設定密碼").matches(/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,20}$/, {
          message: "6-20位英數(須包含1個數字、1個英文字母)",
          excludeEmptyString: true
        }),
        confirm: yup
            .string()
            .required("請確認密碼")
            .oneOf([yup.ref("password")], "密碼不一致，請再確認"),
      }),
      yup.object({
        creditCard: yup.string().required("請輸入信用卡號").matches(/^(\d{4}\s*){4}$/, {
          message: "格式錯誤，請再確認",
          excludeEmptyString: true
        }),
        creditMY: yup.string().required("請輸入有效月/年").matches(/^(0?[1-9]|1[012])\s\/\s\d{2}$/, {
          message: "格式錯誤，請再確認",
          excludeEmptyString: true
        }),
        creditCVV: yup.string().required("請輸入安全碼").matches(/^\d{3}$/, {
          message: "請輸入3位數安全碼",
          excludeEmptyString: true
        }),
        invoiceType: yup
            .string()
            .required()
            .oneOf(["1", "2"]),
        invoiceTitle: yup.string().when('invoiceType', (invoiceType, schema) => {
          return invoiceType === '2' ? schema.required("請輸入公司抬頭") : schema;
        }),
        invoiceUniform: yup.string().when('invoiceType', (invoiceType, schema) => {
          return invoiceType === '2' ? schema.required("請輸入統一編號").matches(/^\d{8}$/, {
            message: "格式錯誤，請再確認",
            excludeEmptyString: true
          }) : schema;
        }),
      }),
      yup.object({
        agreeTerms: yup.bool().required("必須勾選才能繼續").equals([true], "必須勾選才能繼續"),
        agreeOrder: yup.bool().required("必須勾選才能繼續").equals([true], "必須勾選才能繼續"),
      }),
    ];

    // Initial values
    const paidSuccess = ref(false);
    const paidEmail = ref("");
    const errorMsg = ref("");
    const formData = ref({});
    const initialStep = computed(() => (props.isVerified === 'true') ? 2 : 0);
    const initialEmail = computed(() => (props.isVerified === 'true') ? props.email : (formData.value['email'] || ""));
    const formInitialValues = computed(() => (
        [
          {email: initialEmail.value},
          {nickname: formData.value['nickname'] || ""},
          {invoiceType: "1"},
          {agreeTerms: true}
        ]
    ));

    const freeEnd = computed(() => {
      let now = new Date();
      let nextMonth = parseInt(now.getMonth());
      if (props.product === 'yearly') {
        let nextYear = parseInt(now.getFullYear())+1;
        now.setFullYear(nextYear);
      } else {
        nextMonth++;
        now.setMonth(nextMonth);
      }

      if (now.getMonth() !== (nextMonth%12)) {
        now.setDate(0);
      }
      return now.toLocaleDateString();
    });

    /**
     * Only Called when the last step is submitted
     */
    function onSubmit(result) {
      //console.log("onSubmit!");
      //console.log(result);
      const checkoutProduct = props.product;
      const checkoutPrice = localStorage.getItem("price");
      paidSuccess.value = result.paidSuccess;
      paidEmail.value = result.paidEmail ?? "";
      errorMsg.value = result.errorMsg ?? "";
      
      // send ga event
      if(result.paidSuccess == true) {
        ga('smg_tracker.send', 'event', "payment-flow", "checkout-success", checkoutProduct, checkoutPrice);
        dataLayer.push({'event': 'checkout-success', 'order' : result.paidEmail});
      } else {
        ga('smg_tracker.send', 'event', "payment-flow", "checkout-failed", checkoutProduct, 0);
        dataLayer.push({'event': 'checkout-failed'});
      }
    }

    const isCompanyType = ref(false);

    onMounted(() => {
      showCheckoutForm.value = true;
      //console.log('on mounted!')
    })

    return {
      showCheckoutForm,
      isLogin,
      showLogin,
      validationSchema,
      formData,
      initialStep,
      initialEmail,
      formInitialValues,
      freeEnd,
      onSubmit,
      isCompanyType,
      paidSuccess,
      paidEmail,
      errorMsg
    };
  },
  data() {
    return {
      products: {
        'trial': {
          'title': '月付方案(試閱優惠)',
          'content': '自動更新並以月付89元扣款，我們將在試閱期結束的前三天寄信提醒您。您可隨時於會員專區更換方案或取消訂閱。',
          'price': '1'
        },
        'monthly': {
          'title': '月付方案',
          'content': '到期後自動更新並以月付89元扣款，您可隨時於會員專區更換方案或取消訂閱。',
          'price': '89'
        },
        'yearly': {
          'title': '年付方案',
          'content': '到期後自動更新並以年付899元扣款，您可隨時於會員專區更換方案或取消訂閱。',
          'price': '899'
        },
      }
    }
  },
  methods: {
    cardNoFormat(event) {
      event.target.value = event.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
      return event;
    },
    expireDateFormat(event) {
      let onlyNum = event.target.value.replace(/[^\dA-Z]/g, '').trim();
      event.target.value = (onlyNum.length > 2) ? onlyNum.replace(/(^.{2})/g, '$1 / ') : onlyNum;
      return event;
    },
    stepChange(event) {
      //console.log("stepChange", event);
      this.formData = event;
      this.$refs.sectionDom.scrollIntoView();
    },
    invoiceChange(event) {
      //console.log("invoiceChange", event);
      this.isCompanyType = (event.target.value === '2');
    },
    mailUsed() {
      this.$refs.sl.open();
    },
    inputFocusFunc(e) {
        inputFocus(e);
    },
    inputBlurFunc(e) {
        inputBlur(e);
    }
  }
};
</script>